export default function loadMoreProducts() {
  const btn = document.getElementById("load-more-btn");
  const grid = document.getElementById("products-grid");
  const data = window.wooLoadMore;

  if (!grid || !data) return;

  const initialMaxPages = btn ? parseInt(btn.dataset.max) : 0;

  if (!initialMaxPages || initialMaxPages <= 1) return;

  let page = 1;
  let loading = false;
  let currentCategorySlug = data.catSlug || "";
  let maxPages = initialMaxPages;

  if (btn) btn.style.display = "none";

  let sentinel = document.createElement("div");
  sentinel.classList.add("load-more-sentinel");
  grid.insertAdjacentElement("afterend", sentinel);

  const observer = new IntersectionObserver(
    (entries) => {
      if (entries[0].isIntersecting && !loading && page < maxPages) {
        load();
      }
    },
    { rootMargin: "200px" },
  );

  requestAnimationFrame(() => observer.observe(sentinel));

  // Listen for filter changes from woo-filters
  window.addEventListener("woo-filter-changed", (e) => {
    currentCategorySlug = e.detail.categorySlug;
    maxPages = e.detail.maxPages || initialMaxPages;
    page = 1; // Reset page counter when filter changes

    // Check if sentinel was removed from DOM (happens when all pages are loaded)
    if (!document.contains(sentinel)) {
      // Recreate sentinel
      observer.disconnect();
      sentinel = document.createElement("div");
      sentinel.classList.add("load-more-sentinel");
      grid.insertAdjacentElement("afterend", sentinel);
      observer.observe(sentinel);
    } else {
      // Sentinel still exists, just reset its state
      sentinel.classList.remove("has-error");
      sentinel.classList.remove("is-loading");
      sentinel.innerHTML = "";
    }
  });

  async function load() {
    if (loading) return;
    loading = true;
    sentinel.classList.remove("has-error");
    sentinel.classList.add("is-loading");
    sentinel.innerHTML = ""; // clear any retry button

    try {
      const nextPage = page + 1;
      const html = await fetchProducts(nextPage);

      console.log(html);

      append(html);
      page = nextPage;

      if (page >= maxPages) {
        observer.disconnect();
        sentinel.remove();
      }
    } catch (err) {
      console.error("Load more failed:", err.message || err);
      sentinel.classList.add("has-error");
      bindRetry();
    } finally {
      loading = false;
      sentinel.classList.remove("is-loading");
    }
  }

  function bindRetry() {
    // Pause the observer while in error state
    observer.unobserve(sentinel);

    const retryBtn = document.createElement("div");
    retryBtn.textContent = "Failed to load — try again";
    retryBtn.classList.add("load-more-retry");

    retryBtn.addEventListener(
      "click",
      () => {
        // Resume observer and trigger load
        observer.observe(sentinel);
        load();
      },
      { once: true },
    ); // auto-removes listener after one click

    sentinel.appendChild(retryBtn);
  }

  async function fetchProducts(nextPage) {
    const body = new URLSearchParams({
      action: "firos_load_more_products",
      nonce: data.nonce,
      page: nextPage,
      cat_slug: currentCategorySlug,
    });

    const response = await fetch(data.ajaxUrl, {
      method: "POST",
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      body,
    });

    const json = await response.json();

    if (!json.success) {
      const errorMsg = typeof json.data === "string" ? json.data : JSON.stringify(json.data);
      throw new Error(errorMsg);
    }

    return json.data.html;
  }

  function append(html) {
    const temp = document.createElement("div");
    temp.innerHTML = html;
    while (temp.firstChild) {
      grid.appendChild(temp.firstChild);
    }
  }

  console.log("running");
}
